import * as React from 'react';
import { Result } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { ReactComponent as Titan } from '../assets/titan.svg';
import '../styles/walletLoadRedirect.css';

const WalletLoadRedirect = () => {
  const { search } = useLocation();
  const statuses = new URLSearchParams(search).getAll('status');
  const status = statuses.length === 1 ? statuses[0] : null;
  const messageId =
    status === 'success'
      ? 'wallet-load-redirect-success'
      : status === 'cancel'
      ? 'wallet-load-redirect-cancel'
      : 'wallet-load-redirect-unknown';
  const resultStatus =
    status === 'success'
      ? 'success'
      : status === 'cancel'
      ? 'info'
      : 'warning';

  return (
    <main className="wallet-load-redirect-page">
      <div className="login-logo" aria-hidden="true">
        <Titan />
      </div>
      <section
        className="login-layout wallet-load-redirect-card"
        aria-labelledby="wallet-load-redirect-title"
      >
        <Result
          status={resultStatus}
          title={
            <h1 id="wallet-load-redirect-title">
              <FormattedMessage id={messageId} />
            </h1>
          }
          subTitle={<FormattedMessage id="wallet-load-redirect-close-page" />}
        />
      </section>
    </main>
  );
};

export default WalletLoadRedirect;
